import { createContext, useContext } from 'react';

// Define the type locally (copied from UnitatsContext.tsx)
export interface UnitatDocument {
	_id: string;
	nom: string;
	nom_lowercase: string;
	abreviacio: string;
	abreviacio_lowercase: string;
	descripcio: string;
	user?: string;
	url?: string;
}

// Moved from UnitatsContext.tsx
export const UnitatsContext = createContext<{
	unitats: UnitatDocument[] | undefined | null;
	isFetchingUnitats: boolean;
	fetchUnitatsError: Error | null;
}>({ unitats: null, isFetchingUnitats: true, fetchUnitatsError: null });

// Moved from UnitatsContext.tsx
export const useUnitats = () => {
	const context = useContext(UnitatsContext);
	if (!context) {
		throw new Error('useUnitats must be used within a UnitatsProvider');
	}
	return context;
};
